module.exports = "## Community\n\nIf you want to stay up to date on the development of Material-UI or to reach out the community, you can follow those resources:\n\n- Chat with us on [gitter](https://gitter.im/callemall/material-ui).\n- For help using Material-UI, ask on StackOverflow using the tag\n[material-ui](http://stackoverflow.com/questions/tagged/material-ui).\n- Follow [@MaterialUI](https://twitter.com/MaterialUI) on twitter.\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/discover-more/community.md
 ** module id = 1102
 ** module chunks = 0
 **/